import commonApi from './CommonApi.js';

const unwrap = (promise) => promise
	.then((response) => response)
	.catch((error) => error.response);

export default {
	getAllWords: async () => {
		return await commonApi().get('/v1/admin/moderation/words/getAll')
			.then((response) => response.status == 200 ? response.data : { items: [] })
			.catch((error) => { console.log(error); return { items: [] }; });
	},
	getById: async (parameters) => {
		return await commonApi().get('/v1/admin/moderation/words/getById', { params: parameters })
			.then((response) => response.data)
			.catch((error) => { console.log(error.response); });
	},
	create: async (viewModel) => {
		return await unwrap(commonApi().post('/v1/admin/moderation/words', viewModel));
	},
	edit: async (viewModel) => {
		return await unwrap(commonApi().put('/v1/admin/moderation/words', viewModel));
	},
	delete: async (parameters) => {
		return await unwrap(commonApi().delete('/v1/admin/moderation/words', { params: parameters }));
	},
	getBlockedMessages: async (parameters) => {
		return await commonApi().get('/v1/admin/moderation/blockedMessages/getAll', { params: parameters })
			.then((response) => response.status == 200 ? response.data : { items: [] })
			.catch((error) => { console.log(error); return { items: [] }; });
	},
	test: async (text) => {
		return await commonApi().post('/v1/admin/moderation/test', { text: text })
			.then((response) => response.data)
			.catch((error) => { console.log(error); return { matches: [] }; });
	}
};
